import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * POST `/crm/quotations/{id}/issue`（#83）：DRAFT → ISSUED。
 * body：`updatedAt`、`validUntil?`（省略＝台北發出日 +14 天；不得早於發出日）。
 */
export async function issueQuotation(id, payload) {
  const { data: raw } = await request.post(`/crm/quotations/${id}/issue`, keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
